module.exports = __webpack_public_path__ + "static/media/bforrai.241dbb5a.jpg";